import { CombinedGraphQLErrors } from '@apollo/client';
function readFieldErrors(value) {
    if (typeof value !== 'object' || value === null)
        return {};
    const fieldErrors = {};
    for (const [field, messages] of Object.entries(value)) {
        if (Array.isArray(messages)) {
            const safeMessages = messages.filter(message => typeof message === 'string');
            if (safeMessages.length > 0)
                fieldErrors[field] = safeMessages;
            continue;
        }
        if (typeof messages === 'string')
            fieldErrors[field] = [messages];
    }
    return fieldErrors;
}
export function getGraphQLFieldErrors(error, fieldAliases = {}) {
    if (!CombinedGraphQLErrors.is(error))
        return {};
    const fieldErrors = {};
    for (const graphQLError of error.errors) {
        const errors = readFieldErrors(graphQLError.extensions?.errors);
        for (const [field, messages] of Object.entries(errors)) {
            const formField = fieldAliases[field] ?? field;
            fieldErrors[formField] = [...(fieldErrors[formField] ?? []), ...messages];
        }
    }
    return fieldErrors;
}
export function getGraphQLFieldErrorEntityIds(error, candidateIds) {
    const candidateIdSet = new Set(candidateIds);
    return [...new Set(Object.keys(getGraphQLFieldErrors(error)).map(field => field.split('.')[0]))].filter(id => candidateIdSet.has(id));
}
export function getGraphQLErrorCode(error) {
    if (!CombinedGraphQLErrors.is(error))
        return undefined;
    const code = error.errors[0]?.extensions?.code;
    return typeof code === 'string' ? code : undefined;
}
/**
 * Prefer the first GraphQL error message when present; otherwise fall back to
 * a plain Error message or the caller-supplied default.
 */
export function getFirstGraphQLErrorMessage(error, fallback, options) {
    let message;
    if (CombinedGraphQLErrors.is(error)) {
        message = error.errors[0]?.message ?? fallback;
    }
    else {
        message = error instanceof Error && error.message ? error.message : fallback;
    }
    if (options?.allowedMessages && !options.allowedMessages.includes(message)) {
        return fallback;
    }
    return message;
}
//# sourceMappingURL=get-first-graphql-error-message.js.map